export const productListSlidePerView = 4;
export const listCircleSlidePerView = 6;
export const mWebVisibleKeyListMinLength = 10;
